var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Company',{attrs:{"max-width":"400","loggedUser":_vm.loggedUser}}),(_vm.isAdmin())?_c('Admin',{staticStyle:{"margin-bottom":".5em","margin-top":".5em"},attrs:{"max-width":"400","loggedUser":_vm.loggedUser}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }